import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

/**
 * RoleRoute — wraps a page that requires both:
 *   1. The user to be authenticated (same as PrivateRoute), AND
 *   2. The user's role to be in the `allowedRoles` array.
 *
 * Redirect behaviour:
 *   • Not logged in          → /          (landing page)
 *   • Logged in, wrong role  → /home      (authenticated home, not landing)
 *
 * Usage:
 *   <RoleRoute allowedRoles={['admin', 'super_admin']}>
 *     <AdminDashboard />
 *   </RoleRoute>
 */
const RoleRoute = ({ children, allowedRoles = [] }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-cyan-500"></div>
      </div>
    );
  }

  // Not authenticated at all
  if (!user) {
    return <Navigate to="/" replace />;
  }

  // Authenticated but insufficient role
  if (!allowedRoles.includes(user.role)) {
    return <Navigate to="/home" replace />;
  }

  return children;
};

export default RoleRoute;
